import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import TableRow from '../../atoms/table/TableRow';
import TableCell from '../../atoms/table/TableCell';
import Download from '../../atoms/icons/Download';
import { readableDate } from '../../../helpers/Date';
const StyledTableRow = styled(TableRow) `
    @media only screen and (min-width: 540px) {
        flex-wrap: nowrap;
    }

    &:hover {
        .icon {
            fill: ${props => props.theme.secondary};
        }
    }
`;
const StyledDownloadWrapper = styled.div `
    display: inline-flex;
    justify-content: center;

    @media only screen and (max-width: 540px) {
        padding: 5px 10px;
        background-color: ${props => props.theme.primary.base};
        border-radius: 4px;
    }

    span {
        color: ${props => props.theme.primary.base};
        margin-right: 6px;

        @media only screen and (min-width: 540px) {
            display: none;
        }

        @media only screen and (max-width: 540px) {
            color: white;
        }
    }
`;
const StyledDownload = styled(Download) `
    fill: ${props => props.theme.primary.base};
    transition: all 100ms ease-in-out;

    @media only screen and (max-width: 540px) {
        fill: white;
    }
`;
const StyledTableCell = styled(TableCell) `
    flex: 0;

    @media only screen and (min-width: 992px) {
        min-width: 90px;
    }

    svg {
        display: block;
    }
`;
const DocumentTableRow = ({ document }) => {
    return (_jsxs(StyledTableRow, { download: true, href: `${window.location.pathname}/${document.filename}`, children: [_jsx(TableCell, { label: "Datum", value: readableDate(document.date) }), _jsx(TableCell, { label: "Documentsoort", value: document.type }), _jsx(StyledTableCell, { children: _jsxs(StyledDownloadWrapper, { children: [_jsx("span", { children: "Download" }), _jsx(StyledDownload, { className: "icon" })] }) })] }));
};
export default DocumentTableRow;
